import { combineReducers } from 'redux-immutable'
import consentLogGetReducer from './consent-log-get-reducer'
import consentLogCreateReducer from './consent-log-create-reducer'

export default combineReducers({
    consentLogGet: consentLogGetReducer,
    consentLogCreate: consentLogCreateReducer,
})


// WEBPACK FOOTER //
// ./src/reducers/consent-log/index.js